import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Dimmer, Loader } from 'semantic-ui-react'

class TransitPage extends Component {
  render() {
    return (
      <Dimmer active inverted>
        <Loader />
      </Dimmer>
    );
  }
}

export default connect(null,null)(TransitPage)



/** WEBPACK FOOTER **
 ** ./src/containers/transitPage.js
 **/